<template>
  <div>
    <success-fade-alert ref="alertSuccess" :msg="alert.success" />
    <fade-alert-danger ref="alertDanger" :msg="alert.error" />

    <b-input-group>
      <VehicleModelDropdown
        ref="vehicleModelDropdown"
        :vehicleModelId.sync="compVehicleModelId"
      />

      <b-input-group-append>
        <b-button v-b-modal.modalVehicle>
          <i class="tim-icons icon-simple-add" style="text-align: center" />
        </b-button>
      </b-input-group-append>
    </b-input-group>

    <b-modal
      ref="modalVehicle"
      id="modalVehicle"
      title="Cadastro: Modelo de equipamento"
      :ok-title="$t('geral.save')"
      :cancel-title="$t('geral.cancel')"
    >
      <div>
        <b-col>
          <vehicle-model :model.sync="modelLocal" :modelstate="modelstate" />
        </b-col>
      </div>

      <template #modal-footer="{}">
        <div style="text-align: right; width: 100%">
          <b-button
            variant="green"
            @click="saveModelVehicle"
            style="margin-left: 5px"
          >
            {{ $t("geral.confirm") }}
          </b-button>

          <b-button class="ml-2" variant="danger" @click="cancelModal">
            {{ $t("geral.cancel") }}
          </b-button>
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
export default {
  name: "VehicleModelDropdownModal",
  props: {
    vehicleModelId: Number,
  },
  components: {
    VehicleModelDropdown: () =>
      import("@/components_rms/System/VehicleModel/VehicleModelDropdown.vue"),
    "vehicle-model": () =>
      import("@/components_rms/System/VehicleModel/VehicleModel.vue"),
    "success-fade-alert": () => import("@/components/SuccessFadeAlert.vue"),
    "fade-alert-danger": () => import("@/components/FadeAlertDanger.vue"),
  },
  data() {
    return {
      alert: {
        error: "Erro ao criar registro: ",
        success: "Registro criado com sucesso",
      },
      modelstate: [],
      modelLocal: {
        name: "",
        size: null,
        brandId: null,
      },
    };
  },
  computed: {
    compVehicleModelId: {
      get: function () {
        return this.vehicleModelId;
      },
      set: function (value) {
        this.$emit("update:vehicleModelId", value);
      },
    },
  },
  methods: {
    saveModelVehicle() {
      this.modelstate = [];
      let obj = {
        name: this.modelLocal.name,
        size: this.modelLocal.size,
        brandId: this.modelLocal.brandId,
      };
      this.$apiScheduler
        .post("/vehicleModel/create/", obj)
        .then((response) => {
          this.$refs.vehicleModelDropdown.loadVehicleModels();
          this.$emit("update:vehicleModelId", response.data.id);
          this.$refs.modalVehicle.hide();
          this.clearFields();
        })
        .catch((error) => {
          if (error.response.data == null) {
            this.modelstate = [];
            this.alert.error = error.response.title;
            this.showToastError();
            return;
          }
          if (error.response.data.errors != null) {
            this.modelstate = error.response.data.errors;
            this.alert.error = error.response.data.title;
            this.showToastError();
            return;
          }
          if (error.response.data.errorMessage) {
            this.modelstate = [];
            this.alert.error = error.response.data.errorMessage;
            this.showToastError();
            return;
          }
        });
    },
    clearFields() {
      this.modelLocal = {
        name: "",
        size: null,
        brandId: null,
      };
    },
    cancelModal() {
      this.$refs.modalVehicle.hide();
    },
    showToastError(append = false) {
      this.$bvToast.show("example-toast");
      this.$bvToast.toast(this.alert.error, {
        autoHideDelay: 5000,
        toaster: "b-toaster-top-full",
        variant: "danger",
        appendToast: append,
      });
    },
  },
};
</script>